import axios, { AxiosError } from "axios"
import { firebaseauth } from "../mp-database/firebaseConfig"
import { getEnv } from "../../utils/env"

const cubeClient = new axios.Axios({
  baseURL: `${getEnv("BASE_REPORTING_API")}/cube/load`,
  responseType: "json"
})

cubeClient.interceptors.request.use(async config => {
  const token = await firebaseauth.currentUser.getIdToken(false)

  config.headers["Authorization"] = `Bearer ${token}`

  return config
})

cubeClient.interceptors.response.use(response => {
  const responseData = JSON.parse(response.data)

  if (response.status !== 200) {
    throw new AxiosError(
      response.statusText || responseData.message,
      response.status.toString()
    )
  }

  return responseData
})

export default cubeClient
